/**
 * Modal com os Termos de Serviço. Abre ao clicar em "Termos de Serviço" na tela de login.
 * Conteúdo editável via i18n (terms.*).
 */

import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { X } from 'lucide-react';

export default function TermsOfServiceModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-[100]" onClick={onClose}>
      <div
        className="bg-gray-800 rounded-2xl border border-purple-500/20 shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700 shrink-0">
          <h2 className="text-xl font-bold text-white">{t('terms.title')}</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-white rounded-lg transition"
            aria-label={t('common.close')}
          >
            <X size={22} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4 text-gray-300 text-sm space-y-4">
          <p><Trans i18nKey="terms.intro" /></p>
          <section>
            <h3 className="text-white font-semibold mb-1">{t('terms.section1Title')}</h3>
            <p>{t('terms.section1Body')}</p>
          </section>
          <section>
            <h3 className="text-white font-semibold mb-1">{t('terms.section2Title')}</h3>
            <p>{t('terms.section2Body')}</p>
          </section>
          <section>
            <h3 className="text-white font-semibold mb-1">{t('terms.section3Title')}</h3>
            <p><Trans i18nKey="terms.section3Body" /></p>
          </section>
          <section>
            <h3 className="text-white font-semibold mb-1">{t('terms.section4Title')}</h3>
            <p>{t('terms.section4Body')}</p>
          </section>
          <p className="text-gray-500 text-xs pt-2">{t('terms.lastUpdate')}</p>
        </div>
      </div>
    </div>
  );
}
